import React, { Component } from "react";
import novajson from '../DeckBuilderComponents/novablitz_full.json';
import _ from 'lodash';
import uniqBy from 'lodash/uniqBy';
import map from 'lodash/map';
import * as firebasedb from "../firebase/firebase";
import FiltersV2 from "./FiltersV2";
import DeckDetails from "../DeckBuilderComponents/DeckDetails";
import DeckList from "../DeckBuilderComponents/Decklist";
import { Button, Badge, Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import * as routes from '../Constants/routes';
import { db, firebase } from '../firebase';
import 'url-search-params-polyfill';


class DeckBuilderV2 extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      decklist: [],
      deckCount: 0,
      nanoCost: 0,
      decks: [],
      saveform: false,
      deckName: "",
      author: this.context.userName,
      description: "",
      preview: false,
      previewCard: "",
      isOpen: true,
      isOpenDD: false,
      isOpenF: true,
      isOpenCG: true,
      deckId: ""

    }

  this.cardClickHandler = this.cardClickHandler.bind(this);
  this.removecard = this.removecard.bind(this);
  this.stateupdate = this.stateupdate.bind(this);
  this.save = this.save.bind(this);
  this.deckNameChange = this.deckNameChange.bind(this);
  this.authorChange = this.authorChange.bind(this);
  this.descriptionChange = this.descriptionChange.bind(this);
  this.deckDetailsDisplay = this.deckDetailsDisplay.bind(this);
  this.cardPreview = this.cardPreview.bind(this);
  this.toggle = this.toggle.bind(this);
  this.toggleDD = this.toggleDD.bind(this);
  this.toggleF = this.toggleF.bind(this);
  this.toggleCG = this.toggleCG.bind(this);
  this.update = this.update.bind(this);
  this.addCard = this.addCard.bind(this);

  }

  componentDidMount () {

      var thethis = this;
      var search = this.props.location.search;
      const params = new URLSearchParams(search);
      const tags = params.get('query');
      if (tags != null){
        this.setState({deckId: tags})
      }
      if (tags != null){
      db.getDeck(tags).then(snapshot =>
        thethis.setState(() =>
          (
            { decklist: snapshot.cards,
              deckName: snapshot.deckName,
              deckCount:snapshot.cardCount,
              nanoCost: snapshot.nanoCost,
              description: snapshot.description
            }))
        ).catch(function(error) {
            console.error("Error updating document: ", error);
        });
      }

    }

  stateupdate(data){
    this.setState({decklist: data})
  }

  cardClickHandler(event) {
    console.log(event.target.id + " card was clicked")

          var theDeckList = this.state.decklist;
          var firstBy = require('thenby');
          var thenBy = require('thenby');
          var cardId = event.target.id;
          var cardname = "";
          var cardqty = 1;
          var aspectIcon = '';
          var color = '';
          var cardCost = "";
          var rarityIcon = "";
          var oktoAdd = false;
          var increaseDeckCount = false
          var cardNano = 0;
          var nanoCost = 0;

          //functions provided by lodash include
          var includedAspects = _.map(_.uniqBy(theDeckList, 'AspectIcon'), function (item) {
              return {
                  AspectIcon: item.AspectIcon

              };
          });


          if (this.state.deckCount == 60) {
              alert("Hey! Decks cannot exceed 60 cards.");
          }
          else {
              var result = _.find(theDeckList, { "CardId": cardId });
              if (result)
              {
                _.forOwn(theDeckList, function(value, key) {
                  if (value.CardId == cardId) {
                      if (value.CardQty < 3) {
                          value.CardQty++;
                          cardNano = value.NanoCost;
                          increaseDeckCount = true;
                      }
                      else { alert("Hey! Only three copies of a card allowed!"); };
                  };

                } );
              }
              else {
                  _.forOwn(novajson.Cards, function(value, key) {
                      if (value.CardId == cardId) {
                          cardname = value.Name;
                          cardCost = value.Cost;

                          switch (value.Aspect) {
                              case "C":
                                  aspectIcon = "ChaosIcon2";
                                  break;
                              case "T":
                                  aspectIcon = "TechnologyIcon2";
                                  break;
                              case "A":
                                  aspectIcon = "ArcaneIcon2";
                                  break;
                              case "D":
                                  aspectIcon = "DivineIcon2";
                                  break;
                              case "N":
                                  aspectIcon = "NatureIcon2";
                                  break;
                              default:
                                  aspectIcon = "Unknown";
                          }

                          switch (value.Rarity) {
                              case "C":
                                  rarityIcon = "Rarity_Common.png";
                                  cardNano = 40;
                                  break;
                              case "R":
                                  rarityIcon = "Rarity_Rare.png";
                                  cardNano = 200;
                                  break;
                              case "E":
                                  rarityIcon = "Rarity_Epic.png";
                                  cardNano = 1000;
                                  break;
                              case "L":
                                  rarityIcon = "Rarity_Legendary.png";
                                  cardNano = 4000;
                                  break;
                              default:
                                  aspectIcon = "Unknown";
                          }
                      }
                  })

                   //Check to make sure only 2 aspects are used.
                   if (includedAspects.length > 1) {
                       _.forOwn(includedAspects, function(value, key) {
                          if (value.AspectIcon == aspectIcon) {
                              oktoAdd = true;
                          }
                      });
                  } else { oktoAdd = true; }

                   if (oktoAdd) {
                       theDeckList.push({ 'CardQty': cardqty, 'CardId': cardId, 'CardCost': cardCost, 'CardName': cardname, 'RarityIcon': rarityIcon, 'NanoCost': cardNano, 'AspectIcon': aspectIcon });

                       theDeckList.sort(firstBy("CardCost").thenBy("CardName", { ignoreCase: true }));
                       increaseDeckCount = true;
                   }
                   else { alert("Hey! Only two Aspects allowed per deck!"); }
              }
          };

          if (increaseDeckCount)
          {
            this.setState({deckCount: this.state.deckCount + 1})
            this.setState({nanoCost: this.state.nanoCost + cardNano})
            console.log(this.state.nanoCost);
          }
          this.setState({decklist: theDeckList})
  }

  removecard(event) {
      var cardId = event.currentTarget.id;
      var theDeckList = this.state.decklist;
      var C = "";
      var cardNano = 0;

      _.forOwn(theDeckList, function(value, key) {
        if (value.CardId == cardId) {
            cardNano = value.NanoCost;
            if (value.CardQty > 1) {
                value.CardQty--;

            }
            else { C = value.CardId};
        };
      } );

      var updatedDecklist = theDeckList.filter(function (card) {
          return (card.CardId != C);
      });
      this.setState({nanoCost: this.state.nanoCost - cardNano})
      this.setState({deckCount: this.state.deckCount - 1})
      this.setState({decklist: updatedDecklist})
      console.log(this.state.nanoCost);
  };

  addCard(event) {
    var cardId = event.currentTarget.id;
    var thethis = this;
    var theDeckList = this.state.decklist;
    var C = "";
    var cardNano = 0;

    _.forOwn(theDeckList, function(value, key) {
      if (value.CardId == cardId) {
          cardNano = value.NanoCost;
          if (value.CardQty < 3) {
              value.CardQty++;

            var updatedDecklist = theDeckList.filter(function (card) {
                return (card.CardId != C);
            });

            thethis.setState({nanoCost: thethis.state.nanoCost + cardNano})
            thethis.setState({deckCount: thethis.state.deckCount + 1})
            thethis.setState({decklist: updatedDecklist})

          }
          else { alert("Hey! Only three copies of a card allowed!"); };
      };
    });
  }

  cardPreview(card) {
      console.log("this is your card " + card )
      if (this.state.preview) {
        this.setState({preview: false})
      }
      else {
        this.setState({preview: true})
      }

      this.setState({previewCard: card})

  }

  deckDetailsDisplay(event) {
    if (this.state.saveform == false)
    this.setState({saveform: true})
    else {
      this.setState({saveform: false})
    }
  }

  save(event) {
    var theDeckList = this.state.decklist;
    var addDate = new Date();
    var thethis = this;

    var includedAspects = _.map(_.uniqBy(theDeckList, 'AspectIcon'), function (item) {
        return {
            AspectIcon: item.AspectIcon
        };
    });
    firebasedb.db.collection("deckDetails").add({
        deckName: this.state.deckName,
        cards: theDeckList,
        author: this.context.userName,
        authorId: this.context.authUserId,
        description: this.state.description,
        nanoCost: this.state.nanoCost,
        cardCount: this.state.deckCount,
        addDate: addDate,
        upVotes: 0,
        voters: [],
        aspects: includedAspects
    })
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
        thethis.props.history.push(routes.DECKVIEW + docRef.id);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });

  }

  update(event) {
    var theDeckList = this.state.decklist;
    var updateDate = new Date();
    var thethis = this;

    var includedAspects = _.map(_.uniqBy(theDeckList, 'AspectIcon'), function (item) {
        return {
            AspectIcon: item.AspectIcon
        };
    });

    firebasedb.db.collection("deckDetails").doc(this.state.deckId).update({
        deckName: thethis.state.deckName,
        cards: theDeckList,
        description: thethis.state.description,
        nanoCost: thethis.state.nanoCost,
        cardCount: thethis.state.deckCount,
        updateDate: updateDate,
        aspects: includedAspects
    })
    .then(function(docRef) {
        console.log("Document updated with ID: ",  thethis.state.deckId);
        thethis.props.history.push(routes.DECKVIEW + thethis.state.deckId);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });



  }

  deckNameChange(event) {
    this.setState({deckName: event.target.value})
  }

  authorChange(event) {
    this.setState({author: event.target.value})
  }

  descriptionChange(value) {
    this.setState({description: value})
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggleDD() {
    this.setState({
      isOpenDD: !this.state.isOpenDD
    });
  }

  toggleF() {
    this.setState({
      isOpenF: !this.state.isOpenF
    });
  }

  toggleCG() {
    this.setState({
      isOpenCG: !this.state.isOpenCG
    });
  }

  render() {
    var deckListStyle = {
      maxWidth: 500,
      justifyContent: "center"
    };

    var buttonGroupStyle = {
      position: "fixed",
      marginTop: 50,
      backgroundColor: "black",
      justifyContent: "center",
      borderBottomStyle: "solid",
      borderTopStyle: "solid",
      borderColor: "darkslategray",
      paddingTop: 5,
      paddingBottom: 5,
      zIndex: 1041
    }

    var deckSectionStyle = {
      marginTop:100,
      justifyContent: "center"
    }

    var rowStyle = {
      justifyContent: "center"
    }

    var deckDetailsStyle = {
      marginBottom:10
    }

    return (
      <React.Fragment>
      <div className="Site-content">

        <div style={buttonGroupStyle} className="btn-group container-fluid" role="group" aria-label="...">

          <Button className="mr-2 rounded" data-target="#decklist" data-toggle="collapse" onClick={this.toggle} >
            Deck List <Badge color="info">{this.state.deckCount}</Badge>
          </Button>

          <Button className="mr-2 rounded" data-target="#collapseDeckDetails" data-toggle="collapse" onClick={this.toggleDD}>Details</Button>
          <Button className="mr-2 rounded"  onClick={this.toggleF} >Filters</Button>
          <Button  className="mr-2 rounded btn btn-default" onClick={this.toggleCG} >Gallery</Button>
          <a href="https://docs.google.com/document/d/1_hL6hSs85-IvJO9IvPGEJl9qOetlDDS0v82P3WpwLak/edit?usp=sharing" target="_blank"><i className="far fa-question-circle fa-2x mr-2"></i></a>
        </div>
      <div className="container" style={deckSectionStyle}>
      <div style={rowStyle} className="row">
      <div id="deck" className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" style={deckListStyle} >
        <Collapse  id="collapseExample" className="navbar-dark bg-dark" isOpen={this.state.isOpen}>
          <DeckList decklist={this.state.decklist} deckcount={this.state.deckCount} cardPreview={this.cardPreview}
          clickHandler={this.removecard} deckDetailsHandler={this.state.deckDetailsDisplay} nanoCost={this.state.nanoCost}
          preview={this.state.preview} previewCard={this.state.previewCard} addCardHandler={this.addCard} />
        </Collapse>
      </div>

      <Collapse style={deckDetailsStyle} className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6" id="collapseDeckDetails" isOpen={this.state.isOpenDD}>
        <DeckDetails deckSave={this.save} deckNameHandler={this.deckNameChange} authorHandler={this.authorChange} descriptionHandler={this.descriptionChange}
        author={this.context.userName} description={this.state.description} deckName={this.state.deckName} deckEdit={this.update} deckId={this.state.deckId} />
      </Collapse>
      </div>
      </div>
      <div className="container">
      <div className="row">
      <FiltersV2 clickHandler={this.cardClickHandler} isOpenF={this.state.isOpenF} isOpenCG={this.state.isOpenCG} />
      </div>
      </div>
      </div>
      </ React.Fragment>
    );
  }
}

DeckBuilderV2.contextTypes = {
  authUser: PropTypes.object,
  userName: PropTypes.string,
  inGameName: PropTypes.string,
  displayIGN: PropTypes.bool,
  authUserId: PropTypes.string
};

export default withRouter(DeckBuilderV2);



// WEBPACK FOOTER //
// ./src/DBV2/DeckbuilderV2.js